import './index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import store from '@/store';

import { AppRouter } from './App';

const renderApp = () => {
    createRoot(document.getElementById('root')).render(
        <StrictMode>
            <Provider store={store}>
                <BrowserRouter>
                    <AppRouter />
                </BrowserRouter>
            </Provider>
        </StrictMode>,
    );
};

if (import.meta.env.VITE_USE_MSW === 'true') {
    const { worker } = await import('./mocks/msw/browser.js');
    await worker.start({ onUnhandledRequest: 'bypass' });
}

renderApp();
